import project1 from '../assets/project1.png';
import project2 from '../assets/project2.png';
import project3 from '../assets/project3.png';
import gameoflife from '../assets/gameoflife.png'
import sorthattest from '../assets/sorthattest.png'
import puppyBlog from '../assets/puppyBlog.png'

const PROJECTS = [
  {
    id: 1,
    title: 'Find your city',
    description: 'A Relocation Match based on your values',
    link: 'https://findyourcity.netlify.app/',
    image: project1,
    tools:'JavaScript | React | NodeJS | Express | Semantic-UI | Jest'

  },
  {
    id: 2,
    title:'Puppy Blog',
    description:'Full stack Flask-Python-PostgreSQL app ',
    link: 'https://social-puppy-blog.herokuapp.com/',
    image: puppyBlog,
    tools:'Python | Flask | PostgreSQL | Jinja | Pillow | Bcrypt'
    
  },
  {
    id: 3,
    title: 'AirBnB optimal',
    description: 'AirBnB Optimal Listing Calculator',
    link: 'https://optimal-airbnb.netlify.app/',
    image: project3,
    tools:'JavaScript | React | NodeJS | Express | Redux | Axios'
  },
  {
    id:4,
    title:'Game of Life',
    description:'A Cellular Automaton',
    link: 'https://mygameoflife.netlify.app/',
    image: gameoflife,
    tools:'JavaScript | React | React Hooks | CSS  '
  },
  {
    id:5,
    title: 'Dragonstack',
    description: 'A React-Node Fullstack Project',
    link: 'https://github.com/anatulea/dragonstack',
    image: project2,
    tools:'JavaScript | React | Redux | NodeJS | Express | PostgreSQL'
  },
  {
    id:6,
    title:'Hogwards Houses',
    description:'Hogwards Sorting Hat Test',
    link: 'https://hogwards-hat-test.netlify.app/',
    image: sorthattest,
    tools:'JavaScript | React | Semantic-UI | SurveyJS'
  }
];

export default PROJECTS;
